import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusModalComponent } from './status-modal/status-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModalModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { PriorityModalComponent } from './priority-modal/priority-modal.component';
import { WidgetModule } from 'src/app/shared/widget/widget.module';
import { BugModalComponent } from './bug-modal/bug-modal.component';
import { EventModalComponent } from './event-modal/event-modal.component';
import { NgxSelectModule } from 'ngx-select-ex';
import { CustomSelectOptions } from 'src/app/select-options';
import { ArtifactSettingModalComponent } from './artifact-setting-modal/artifact-setting-modal.component';
import { SubroleModalComponent } from './subrole-modal/subrole-modal.component';
import { ColumnModalComponent } from './column-modal/column-modal.component';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { FeeModalComponent } from './fee-modal/fee-modal.component';

@NgModule({
  declarations: [
    StatusModalComponent,
    PriorityModalComponent,
    BugModalComponent,
    EventModalComponent,
    ArtifactSettingModalComponent,
    SubroleModalComponent,
    ColumnModalComponent,
    FeeModalComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    NgbNavModule,
    FormsModule,
    ReactiveFormsModule,
    SweetAlert2Module,
    NgbModalModule,
    WidgetModule,
    PipesModule,
    NgxSelectModule.forRoot(CustomSelectOptions),
  ],
  exports: [
    StatusModalComponent,
    PriorityModalComponent,
    BugModalComponent,
    EventModalComponent,
    ArtifactSettingModalComponent,
    SubroleModalComponent,
    ColumnModalComponent,
    FeeModalComponent
  ]
})
export class ModalSettingsModule { }
